import React from 'react';
import {
  Box,
  Typography,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent
} from '@mui/material';

interface DomainSubdomainSelectorProps {
  domain: string;
  subDomain: string;
  domains: string[];
  subDomains: Record<string, string[]>;
  onDomainChange: (event: SelectChangeEvent) => void;
  onSubDomainChange: (event: SelectChangeEvent) => void;
  domainLabel?: string;
  subDomainLabel?: string;
  domainHelperText?: string;
  subDomainHelperText?: string;
  required?: boolean;
}

const DomainSubdomainSelector: React.FC<DomainSubdomainSelectorProps> = ({
  domain,
  subDomain,
  domains,
  subDomains,
  onDomainChange,
  onSubDomainChange,
  domainLabel = "Domain",
  subDomainLabel = "Sub-Domain",
  domainHelperText = "Select a domain below (broad area of focus in community health quality)",
  subDomainHelperText = "Select a sub-domain below (specific area within the chosen domain)",
  required = true
}) => {
  return (
    <Box sx={{ width: '100%', maxWidth: { xs: '100%', md: '48%' } }}>
      <Typography variant="subtitle2" color="text.secondary" sx={{ mt: 1, mb: 0.5 }}>
        {domainHelperText}
      </Typography>
      <FormControl fullWidth margin="normal" required={required}>
        <InputLabel id="domain-label">{domainLabel}</InputLabel>
        <Select
          labelId="domain-label"
          id="domain"
          name="domain"
          value={domain || ''}
          onChange={onDomainChange}
          label={domainLabel}
        >
          {domains.map((domainOption) => (
            <MenuItem key={domainOption} value={domainOption}>
              {domainOption}
            </MenuItem>
          ))}
        </Select>
      </FormControl>

      {domain && subDomains[domain] && subDomains[domain].length > 0 && (
        <Box sx={{ mt: 2 }}>
          <Typography variant="subtitle2" color="text.secondary" sx={{ mb: 0.5 }}>
            {subDomainHelperText}
          </Typography>
          <FormControl fullWidth margin="normal" required={required && subDomains[domain] && subDomains[domain].length > 0}>
            <InputLabel id="subDomain-label">{subDomainLabel}</InputLabel>
            <Select
              labelId="subDomain-label"
              id="subDomain"
              name="subDomain"
              value={subDomain || ''}
              onChange={onSubDomainChange}
              label={subDomainLabel}
            >
              {subDomains[domain].map((subDomainOption) => (
                <MenuItem key={subDomainOption} value={subDomainOption}>
                  {subDomainOption}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
      )}
    </Box>
  );
};

export default DomainSubdomainSelector;
